
import {PropType} from "vue";
import {InternetDiscountPopinDto} from "../../cart/models/InternetDiscountPopinDto";
import AlertMessage from "../ob1/AlertMessage.vue";

export default {
    name: "DiscountPopinInfoShared",
    components: {
        AlertMessage
    },
    props: {
        activeView: {
            type: String,
            required: true
        },
        dto: {
            type: Object as PropType<InternetDiscountPopinDto>,
            required: true
        }
    }
}
